/* eslint-disable i18next/no-literal-string */

import { StyledActionButton } from '../../../styles/table-styles';

export const SupportDetailTickets = () => {
    console.log('SupportDetailTickets');

    const tickets = [
        {
            date: '2023-09-24 08:30:00',
            title: 'Unable to share screen during presentation',
            status: 'open'
        },
        {
            date: '2023-09-24 09:15:00',
            title: 'Audio not working on the virtual classroom software',
            status: 'open'
        },
        {
            date: '2023-09-24 10:00:00',
            title: 'Video lag and freezing issues',
            status: 'resolved'
        },
        {
            date: '2023-09-24 10:45:00',
            title: 'Unable to upload assignment documents',
            status: 'resolved'
        },
        {
            date: '2023-09-24 11:30:00',
            title: 'Software crashes when attempting to join a breakout room',
            status: 'resolved'
        },
        {
            date: '2023-09-24 12:15:00',
            title: 'Chat functionality not working properly',
            status: 'resolved'
        },
        {
            date: '2023-09-24 12:45:00',
            title: 'Difficulty accessing recorded sessions',
            status: 'resolved'
        },
        {
            date: '2023-09-24 13:30:00',
            title: 'Unable to login with provided credentials',
            status: 'resolved'
        }
    ];

    return (
        <>
            <h2>{'Tickets'}</h2>
            {tickets.map((ticket, index) => (
                <div
                    key={index}
                    style={{
                        position: 'relative',
                        marginBottom: '8px',
                        backgroundColor: ticket.status === 'open' ? 'rgb(255,235,235)' : 'rgb(235,255,235)'
                    }}
                >
                    <div style={{ fontWeight: 'bolder', fontSize: '14px' }}>
                        {ticket.title} - {ticket.status}
                    </div>
                    <div style={{ position: 'absolute', top: '0px', right: '3px', fontSize: '10px' }}>
                        {ticket.date}
                    </div>
                </div>
            ))}
            <h2>{'Submit Ticket'}</h2>
            <textarea style={{ width: 'calc(100% - 0px)', height: '200px' }}></textarea>
            <StyledActionButton variant="contained" onClick={() => null}>
                {'Submit Ticket'}
            </StyledActionButton>
        </>
    );
};
